<template>
  <div class="user-center-view">
    <section v-if="userInfo && userInfo.uid" class="module basic-info">
      <!-- <div class="img">
        <img :src="" width="100%" alt="head">
      </div> -->
      <div class="info clear-f">
        <div class="username c21">{{userInfo.nick}}</div>
        <ul class="clear-f">
          <li><span class="gray">手机号码：</span>{{userInfo.mobile}}</li>
          <li><span class="gray">注册时间：</span>{{userInfo.regTime | dateFormat}}</li>
          <li><span class="gray">有效期限：</span>{{userInfo.purExpiry | dateFormat('yyyy-MM-dd')}}</li>
          <li><span class="gray">账户安全：</span><router-link to="/user/changepassword">修改密码</router-link></li>
          <li><span class="gray">我的得分：</span>{{userInfo.score}}</li>
          <!-- <li><span class="gray">我的红花：</span><i class="iconfont icon-flower red"></i> x {{userInfo.flower}}</li> -->
          <li><span class="gray">所在班级：</span>{{userInfo.className || '-'}}</li>
        </ul>
      </div>
    </section>
    <section class="module summary mt10">
      <div class="m-body">
        <h3>学习情况概览</h3>
        <ul class="summary-data clear-f">
          <li>
            <div class="gl-bg-icon bg-through">
              <i class="iconfont icon-through"></i>
            </div>
            <div class="tl">
              <div class="gl-title">已学课程</div>
              <br>
              <div class="gl-num"><animate-number ref="animate_stage" from="0" to="0" mode="manual" duration="1500"></animate-number></div>
            </div>
          </li>
          <li>
            <div class="gl-bg-icon bg-barrier">
              <i class="iconfont icon-barrier"></i>
            </div>
            <div class="tl">
              <div class="gl-title">剩余课程</div>
              <br>
              <div class="gl-num"><animate-number ref="animate_surplus" from="0" to="0" mode="manual" duration="1500"></animate-number></div>
            </div>
          </li>
          <li>
            <div class="gl-bg-icon bg-score">
              <i class="iconfont icon-score"></i>
            </div>
            <div class="tl">
              <div class="gl-title">学习得分</div>
              <br>
              <div class="gl-num"><animate-number ref="animate_score" from="0" to="0" mode="manual" duration="1500"></animate-number></div>
            </div>
          </li>
          <li>
            <div class="gl-bg-icon bg-flower">
              <i class="iconfont icon-flower"></i>
            </div>
            <div class="tl">
              <div class="gl-title">红花数量</div>
              <br>
              <div class="gl-num"><animate-number ref="animate_flower" from="0" to="0" mode="manual" duration="1500"></animate-number></div>
            </div>
          </li>
          <li>
            <div class="gl-bg-icon bg-rank">
              <i class="iconfont icon-rank"></i>
            </div>
            <div class="tl">
              <div class="gl-title">全班排名</div>
              <br>
              <div class="gl-num"><animate-number ref="animate_rank" from="0" to="0" mode="manual" duration="1500"></animate-number></div>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="module chart mt10">
      <header class="m-header">近7天学习记录</header>
      <div class="m-body">
        <chart v-if="day7List && day7List.length > 0" :options="day7RecordOption" :auto-resize="true" class="chart-3D"></chart>
        <div v-else class="day7-empty">您最近7天没有学习了，赶快去学习吧！</div>
      </div>
    </section>
    <section class="module chart chart-l mt10">
      <header class="m-header">近1月积分排名变化</header>
      <div class="m-body">
        <chart v-if="scoreRankList && scoreRankList.length > 0" :options="scoreRankOption" :auto-resize="true"></chart>
        <div v-else class="echarts empty">暂无数据</div>
      </div>
    </section>
    <section class="module chart chart-r mt10">
      <header class="m-header">小红花来源统计</header>
      <div class="m-body">
        <chart v-if="flowerList && flowerList.length > 0" :options="flowerOption" :auto-resize="true"></chart>
        <div v-else class="echarts empty">暂无数据</div>
      </div>
    </section>
  </div>
</template>

<script>
import { dateFormat, timeText } from 'assets/js/functions'
import { graphic } from 'echarts/lib/export'
// 引入柱状图、折线、提示框组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/component/legend')
require('echarts/lib/component/tooltip')

let flowerUrl = require('assets/image/flower-red.svg')

export default {
  name: 'userCenter',
  data () {
    return {
      userInfo: {},
      statistics: {},
      day7List: [],
      day7Series: [],
      day7RecordOption: {},
      scoreRankList: [],
      scoreRankOption: {},
      flowerList: [],
      flowerOption: {}
    }
  },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '个人中心' }])
    this.getUserInfo()
    this.getStatistics()
    this.getDay7Record()
    this.getScoreRank()
    this.getFlowerSource()
  },
  mounted () {
  },
  methods: {
    getUserInfo () {
      this.$http.get('user/info')
        .then(response => {
          this.$nextTick(() => {
            this.userInfo = response
          })
        })
        .catch(() => {
          this.$message.error('获取用户信息失败')
        })
    },
    getStatistics () {
      this.$http.get('user/stat')
        .then(response => {
          this.$nextTick(() => {
            this.statistics = response
            this.startAnimate()
          })
        })
        .catch(() => {
          this.$message.error('获取学习情况概览失败')
        })
    },
    startAnimate () {
      this.$refs.animate_stage.reset(0, this.statistics.stage || 0)
      this.$refs.animate_stage.start()
      this.$refs.animate_surplus.reset(0, (this.statistics.course - this.statistics.stage) || 0)
      this.$refs.animate_surplus.start()
      this.$refs.animate_score.reset(0, this.statistics.score || 0)
      this.$refs.animate_score.start()
      this.$refs.animate_flower.reset(0, this.statistics.flower || 0)
      this.$refs.animate_flower.start()
      this.$refs.animate_rank.reset(0, this.statistics.rank || 0)
      this.$refs.animate_rank.start()
    },
    getDay7Record () {
      this.$http.get('course/record?cycle=3&pageSize=9999&pageIndex=1')
        .then(response => {
          if (response.records && response.records.length > 0) {
            this.$nextTick(() => {
              this.day7List = response.records
              this.setDay7RecordOption()
            })
          }
        })
        .catch(() => {
          this.$message.error('获取近7天学习记录失败')
        })
    },
    setDay7RecordOption () {
      let days = {}
      let seriesCount = 0
      this.day7List.reduce((prevDate, cur) => {
        let dateHour = dateFormat(cur.createTime, 'MM-dd HH')
        let temp = dateHour.split(' ')
        let date = temp[0]
        let hour = Number(temp[1]).toString()
        let day = days[date] || {}
        let arr = day[hour] || []
        arr.push(cur)
        day[hour] = arr
        days[date] = day
        seriesCount = seriesCount < arr.length ? arr.length : seriesCount
        return date
      }, '')

      let hourArr = []
      let dayArr = []
      let serieDataArr = []
      let d = 0
      for (const date in days) {
        let day = days[date]
        dayArr.push(date)
        for (let h = 0; h < 24; h++) {
          if (d === 0) { hourArr.push(h + '点') }
          let arr = day[h.toString()] || []
          for (let s = 0; s < seriesCount; s++) {
            if (d === 0 && h === 0) {
              this.day7Series.push([])
              serieDataArr.push([])
            }
            let val = 0
            let obj = null
            if (arr.length > s) {
              obj = arr[s]
              val = obj.score
            }
            this.day7Series[s].push(obj)
            serieDataArr[s].push([h, d, val])
          }
        }
        d++
      }

      let option = {
        color: ['#83dd69'],
        tooltip: {
          formatter: (params) => {
            let obj = this.day7Series[params.seriesIndex][params.dataIndex]
            if (obj) {
              return `课程：${obj.path}<br />时间：${dateFormat(obj.createTime)}<br />用时：${timeText(obj.time)}<br />得分：${obj.score}<br />正确率：${obj.rate}%<br />通过：${obj.passed ? '是' : '否'}<br />`
            }
          }
        },
        xAxis3D: {
          type: 'category',
          data: hourArr
        },
        yAxis3D: {
          type: 'category',
          data: dayArr
        },
        zAxis3D: {
          type: 'value'
        },
        grid3D: {
          boxWidth: 250,
          boxDepth: 80,
          viewControl: {
            alpha: 5,
            beta: 30,
            zoomSensitivity: 0
          },
          light: {
            main: {
              shadow: true,
              alpha: 30
            }
          }
        },
        series: serieDataArr.map(item => {
          return {
            type: 'bar3D',
            stack: 'stack',
            data: item,
            shading: 'lambert',
            itemStyle: {
              color: (params) => {
                let val = params.value[2]
                if (val === 0) {
                  return seriesCount === 1 || params.seriesIndex === 0 ? '#83dd69' : 'transparent'
                }
                let obj = this.day7Series[params.seriesIndex][params.dataIndex]
                return obj.passed ? '#83dd69' : '#ff5a60'
              }
            }
          }
        })
      }
      this.day7RecordOption = option
    },
    getScoreRank () {
      this.$http.get('user/trend')
        .then(response => {
          this.$nextTick(() => {
            this.scoreRankList = response
            this.setScoreRankOption()
          })
        })
        .catch(() => {
          this.$message.error('获取积分排名数据失败')
        })
    },
    setScoreRankOption () {
      if (this.scoreRankList && this.scoreRankList.length > 0) {
        let dateArr = []
        let scoreArr = []
        let rankArr = []
        for (const item of this.scoreRankList) {
          dateArr.push(item.date.substr(5, 5))
          scoreArr.push(item.score)
          rankArr.push(item.rank)
        }
        let op = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            containLabel: true,
            top: 40,
            bottom: 10,
            left: 10,
            right: 10
          },
          legend: {
            data: ['排名', '积分'],
            selectedMode: false
          },
          xAxis: {
            axisLine: {
              onZero: false
            },
            data: dateArr
          },
          yAxis: [
            {
              type: 'value',
              name: '排名',
              inverse: true,
              nameLocation: 'start',
              splitLine: {
                show: false
              },
              minInterval: 1
            },
            {
              type: 'value',
              name: '积分',
              position: 'right',
              minInterval: 1
            }
          ],
          series: [
            {
              name: '排名',
              type: 'line',
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#FF5A60'
                }
              },
              data: rankArr
            },
            {
              name: '积分',
              yAxisIndex: 1,
              type: 'bar',
              barWidth: '40%',
              itemStyle: {
                normal: {
                  color: new graphic.LinearGradient(
                    0, 0, 0, 1, [{
                      offset: 0,
                      color: '#66FF66'
                    },
                    {
                      offset: 0.5,
                      color: '#83dd69'
                    },
                    {
                      offset: 1,
                      color: '#66CC00'
                    }
                    ]
                  ),
                  shadowColor: 'rgba(0, 0, 0, 0.1)',
                  shadowBlur: 10
                }
              },
              data: scoreArr
            }
          ]
        }
        this.scoreRankOption = op
      }
    },
    getFlowerSource () {
      this.$http.get('user/flowerstat')
        .then(response => {
          this.$nextTick(() => {
            this.flowerList = response
            this.setFlowerOption()
          })
        })
        .catch(() => {
          this.$message.error('获取小红花来源数据失败')
        })
    },
    setFlowerOption () {
      if (this.flowerList && this.flowerList.length > 0) {
        let legendArr = []
        let dataArr = []
        for (const item of this.flowerList) {
          legendArr.push(item.source)
          dataArr.push({
            value: item.count,
            name: item.source
          })
        }
        let op = {
          title: {
            text: '{flower|}',
            x: 'center',
            y: 'center',
            textStyle: {
              rich: {
                flower: {
                  width: 70,
                  height: 70,
                  backgroundColor: {
                    image: flowerUrl
                  }
                }
              }
            }
          },
          tooltip: {
            show: true,
            trigger: 'item',
            formatter: '{b}<br />数量：{c}朵<br />占比：{d}%'
          },
          legend: {
            selectedMode: false,
            bottom: 5,
            data: legendArr
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['40%', '80%'],
            color: ['#67c23a', '#f56c6c', '#409eff'],
            label: {
              normal: {
                position: 'inner',
                formatter: '{c}朵',
                textStyle: {
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 14
                }
              }
            },
            data: dataArr
          }]
        }
        this.flowerOption = op
      }
    }
  }
}
</script>

<style lang="scss">
.user-center-view {
  .basic-info {
    // .img {
    //   width: 120px;
    //   height: 120px;
    //   float: left;
    // }
    .info {
      // margin-left: 170px;
      .username {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      ul {
        margin-right: 3%;
      }
      li {
        float: left;
        width: 33.3%;
        box-sizing: border-box;
        padding-right: 20px;
        line-height: 28px;
      }
      @media screen and (max-width: 1000px) {
        li {
          width: 50%;
        }
      }
    }
  }
  .summary {
    .summary-data {
      padding: 40px 0;
      div {
        display: inline-block;
      }
      li {
        width: 19.5%;
        float: left;
        position: relative;
        text-align: center;
      }
      li + li {
        border-left: 1px solid #ddd;
      }
      .gl-bg-icon {
        height: 60px;
        line-height: 60px;
        width: 60px;
        border-radius: 50%;
        text-align: center;
        vertical-align: top;
        margin-right: 20px;
        background: url("../../assets/image/mask.png") no-repeat center center;
        .iconfont {
          font-size: 36px;
        }
      }
      .bg-through {
        background-color: #55c78c;
        color: #55c78c;
      }
      .bg-barrier {
        background-color: #7db6ff;
        color: #7db6ff;
      }
      .bg-score {
        background-color: #fdad23;
        color: #fdad23;
      }
      .bg-flower {
        background-color: #ff5a60;
        color: #ff5a60;
      }
      .bg-rank {
        background-color: #dca1ff;
        color: #dca1ff;
      }
      @media screen and (max-width: 1300px) {
        .gl-bg-icon {
          display: none;
        }
      }
      .gl-num {
        padding-top: 7px;
        font-size: 30px;
      }
    }
  }
  .chart {
    box-sizing: border-box;
    .echarts {
      width: 100%;
      height: 400px;
    }
    .empty {
      background: url('../../assets/image/nodata.png') no-repeat center center;
      text-align: center;
      line-height: 600px;
    }
    .chart-3D {
      height: 500px;
    }
    &.chart-l,
    &.chart-r {
      width: calc(50% - 7px);
      display: inline-block;
      vertical-align: top;
    }
    &.chart-r {
      margin-left: 9px;
    }
    .day7-empty {
      line-height: 120px;
      text-align: center;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/user/userCenter.vue